module.exports = __webpack_public_path__ + "static/media/template-icon-grey.e69f4ded.svg";